<template>
  <div class="app-container">
    <BjDivider right-fixed>
      <span>{{ $t('AccountSecurityPolicy.top.security') }}</span>
      <template #right>
        <el-button v-permission:SettingUserAccountStrategy @click="reFresh">{{ $t('resetText') }}</el-button>
        <el-button
          v-permission:SettingUserAccountStrategy
          type="primary"
          @click="submitForm('form')"
          >{{ $t('saveText') }}</el-button
        >
      </template>
    </BjDivider>

    <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="200px" inline class="form">
      <!-- <BjDivider>密码安全策略</BjDivider> -->
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.Default')" prop="originalPassword">
            <BjInput
              v-model="form.originalPassword"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.Minlength')" prop="minLength">
            <BjInput
              v-model="form.minLength"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.Maxlength')" prop="maxLength">
            <BjInput
              v-model="form.maxLength"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.lowercase')" prop="lowercaseCount">
            <BjInput
              v-model="form.lowercaseCount"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.uppercase')" prop="uppercaseCount">
            <BjInput
              v-model="form.uppercaseCount"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.special')" prop="specialCharCount">
            <BjInput
              v-model="form.specialCharCount"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.oldpassword')" prop="isPassword">
            <el-switch v-model="form.isPassword" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.top.loginname')" prop="notUsername">
            <el-switch v-model="form.notUsername" />
          </el-form-item>
        </el-col>
      </el-row>

      <BjDivider>{{ $t('AccountSecurityPolicy.bottom.security') }}</BjDivider>
      <el-row class="border">
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.Maxerrors')" prop="maxErrorTime">
            <BjInput
              v-model="form.maxErrorTime"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.Maxrecent')" prop="notRecentCount">
            <BjInput
              v-model="form.notRecentCount"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.errorscode')" prop="maxCheckCaptcha">
            <BjInput
              v-model="form.maxCheckCaptcha"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.verification')" prop="enableCaptcha">
            <el-switch v-model="form.enableCaptcha" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.locked')" prop="enableLock">
            <el-switch v-model="form.enableLock" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.duration')" prop="lockedExpireTime">
            <BjInput
              v-model="form.lockedExpireTime"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.PC')" prop="enableWebMultipleLogin">
            <el-switch v-model="form.enableWebMultipleLogin" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.Mobile')" prop="enableAppMultipleLogin">
            <el-switch v-model="form.enableAppMultipleLogin" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.initial')" prop="forceModifyPassword">
            <el-switch v-model="form.forceModifyPassword" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.after')" prop="enableReLogin">
            <el-switch v-model="form.enableReLogin" />
          </el-form-item>
        </el-col>

        <!-- 是否开启登录安全策略/非必填 , -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('AccountSecurityPolicy.bottom.secondary')" prop="enableSecurity">
            <el-switch v-model="form.enableSecurity" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { settingApi } from '@/api';
export default {
  name: 'SettingUserAccountStrategy',
  data() {
    return {
      colSpan: 8,
      form: {
        _innerMap: {},
        objectVersionNumber: 1,
        _token:
          'b4oZXzhYrKJv03uYjpXxJJNoqyPeH6W3TZhL0zelcHGhnZpNgiAGkCjJMWIS6QFztQgQ6z/MRDP5AxI02Wu5FQ==',
        id: '=ubimsK41X3ZCK_TWqAVnHw===',
        code: 'SKYER',
        name: 'SKYER平台',
        originalPassword: 'admin1234',
        minLength: 6,
        maxLength: 30,
        maxErrorTime: 5,
        digitsCount: 0,
        lowercaseCount: 0,
        uppercaseCount: 0,
        specialCharCount: 0,
        notUsername: false,
        isPassword: false,
        regularExpression: null,
        notRecentCount: 0,
        enablePassword: true,
        enableSecurity: true,
        enableLock: true,
        lockedExpireTime: 86400,
        enableCaptcha: true,
        maxCheckCaptcha: 3,
        enableWebMultipleLogin: true,
        enableAppMultipleLogin: true,
        passwordUpdateRate: 0,
        passwordReminderPeriod: 0,
        forceModifyPassword: false,
        enableReLogin: false,
      },
    };
  },
  computed: {
    rules() {
      const rules = {
        /** 密码安全策略表单验证 */
        originalPassword: { required: true, message: this.$t('AccountSecurityPolicy.top.DefaultRules'), trigger: 'blur' },
        minLength: { required: true, message: this.$t('AccountSecurityPolicy.top.MinlengthRules'), trigger: 'blur' },
        maxLength: { required: true, message: this.$t('AccountSecurityPolicy.top.MaxlengthRules'), trigger: 'blur' },
        lowercaseCount: { required: true, message: this.$t('AccountSecurityPolicy.top.lowercaseRules'), trigger: 'blur' },
        uppercaseCount: { required: true, message: this.$t('AccountSecurityPolicy.top.uppercaseRules'), trigger: 'blur' },
        specialCharCount: { required: true, message: this.$t('AccountSecurityPolicy.top.specialRules'), trigger: 'blur' },

        /** 登录安全策略表单验证 */
        maxErrorTime: { required: true, message: this.$t('AccountSecurityPolicy.bottom.MaxerrorsRules'), trigger: 'blur' },
        lockedExpireTime: { required: true, message: this.$t('AccountSecurityPolicy.bottom.durationRules'), trigger: 'blur' },
      };
    return rules;
    }
  },
  mounted() {
    this.reFresh();
  },
  methods: {
    reFresh() {
      settingApi.getPasswordPolicy().then(res => {
        this.form = res || {};
      });
    },
    updatPasswordPolicy(API_DATA) {
      delete API_DATA.createdBy;
      delete API_DATA.creationDate;
      delete API_DATA.lastUpdateDate;
      delete API_DATA.lastUpdatedBy;
      delete API_DATA.organizationId;
      delete API_DATA.accountPolicy?.id;
      delete API_DATA.accountPolicy?.objectVersionNumber;
      delete API_DATA.accountPolicy?.regularExpression;
      delete API_DATA.accountPolicy?.tenantId;
      delete API_DATA.accountPolicy?._token;
      settingApi.updatPasswordPolicy(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        const API_DATA = this.$lodash.cloneDeep(this.form);
        this.updatPasswordPolicy(API_DATA);
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped>
.border {
  border-bottom: 1px solid #d7dae2;
}
</style>
